__turbopack_context__.v({
  "articleLayout": "page-module__Gko1JG__articleLayout",
  "authorBio": "page-module__Gko1JG__authorBio",
  "authorDescription": "page-module__Gko1JG__authorDescription",
  "authorImage": "page-module__Gko1JG__authorImage",
  "authorImageWrapper": "page-module__Gko1JG__authorImageWrapper",
  "authorName": "page-module__Gko1JG__authorName",
  "authorSmall": "page-module__Gko1JG__authorSmall",
  "authorSmallImg": "page-module__Gko1JG__authorSmallImg",
  "backLink": "page-module__Gko1JG__backLink",
  "badge": "page-module__Gko1JG__badge",
  "categoryBadge": "page-module__Gko1JG__categoryBadge",
  "container": "page-module__Gko1JG__container",
  "faqAnswer": "page-module__Gko1JG__faqAnswer",
  "faqAnswerOpen": "page-module__Gko1JG__faqAnswerOpen",
  "faqAnswerWrapper": "page-module__Gko1JG__faqAnswerWrapper",
  "faqGrid": "page-module__Gko1JG__faqGrid",
  "faqHeader": "page-module__Gko1JG__faqHeader",
  "faqItem": "page-module__Gko1JG__faqItem",
  "faqQuestion": "page-module__Gko1JG__faqQuestion",
  "faqQuestionOpen": "page-module__Gko1JG__faqQuestionOpen",
  "faqSection": "page-module__Gko1JG__faqSection",
  "faqTitle": "page-module__Gko1JG__faqTitle",
  "featuredImage": "page-module__Gko1JG__featuredImage",
  "featuredImageWrapper": "page-module__Gko1JG__featuredImageWrapper",
  "header": "page-module__Gko1JG__header",
  "innerContainer": "page-module__Gko1JG__innerContainer",
  "mainContent": "page-module__Gko1JG__mainContent",
  "metaGroup": "page-module__Gko1JG__metaGroup",
  "metaLabel": "page-module__Gko1JG__metaLabel",
  "metaValue": "page-module__Gko1JG__metaValue",
  "navEmpty": "page-module__Gko1JG__navEmpty",
  "navLabel": "page-module__Gko1JG__navLabel",
  "navLink": "page-module__Gko1JG__navLink",
  "navTitle": "page-module__Gko1JG__navTitle",
  "nextLink": "page-module__Gko1JG__nextLink",
  "postNavigation": "page-module__Gko1JG__postNavigation",
  "prevLink": "page-module__Gko1JG__prevLink",
  "quote": "page-module__Gko1JG__quote",
  "quoteAuthor": "page-module__Gko1JG__quoteAuthor",
  "quoteText": "page-module__Gko1JG__quoteText",
  "sidebar": "page-module__Gko1JG__sidebar",
  "sidebarMeta": "page-module__Gko1JG__sidebarMeta",
  "tableWrapper": "page-module__Gko1JG__tableWrapper",
  "title": "page-module__Gko1JG__title",
  "tocTitle": "page-module__Gko1JG__tocTitle",
  "tocWrapper": "page-module__Gko1JG__tocWrapper",
});
